module.exports = __webpack_public_path__ + "static/media/ThankYou.229b842a.svg";